<template>
<!--  <router-view v-slot="{Component, route}">-->
<!--    <keep-alive>-->
<!--      <component v-if="route.meta?.keepAlive" :is="Component" :key="route.name" ></component>-->
<!--    </keep-alive>-->
<!--    <component  v-if="!route.meta?.keepAlive" :is="Component" :key="route.fullPath"></component>-->
<!--  </router-view>-->
  <router-view></router-view>
</template>

<style>
</style>
